import {
  NOTIFICATION_FETCH_DATA,
  NOTIFICATION_FETCH_DATA_SUCCESS,
  CLEAR_NOTIFICATION_LOADING,
  NOTIFICATIONS_REQUEST,
  NOTIFICATIONS_REQUEST_SUCCESS,
  GLOBAL_NOTIFICATIONS_REQUEST,
  GLOBAL_NOTIFICATIONS_REQUEST_SUCCESS,
  UPDATE_GLOBAL_NOTIFICATIONS_REQUEST,
  UPDATE_GLOBAL_NOTIFICATIONS_SUCCESS,
  CUSTOMER_NOTIFICATIONS_REQUEST,
  CUSTOMER_NOTIFICATIONS_SUCCESS,
  UPDATE_CUSTOMER_NOTIFICATIONS_REQUEST,
  UPDATE_CUSTOMER_NOTIFICATIONS_SUCCESS,
} from '@constants/UHEActionTypes';

/**
 * Notification Action for fetching data
 * @param {*} page page
 * @param {*} filter filter
 * @return {Object} Object
 */
export const notifactionsOnFetchData = (page, filter) => ({
  type: NOTIFICATION_FETCH_DATA,
  page,
  filter,
});

/**
 * Notification Action for successed fetched data
 * @param {*} payload payload object
 * @return {Object} Object
 */
export const notifactionsOnFetchDataSuccess = (payload) => ({
  type: NOTIFICATION_FETCH_DATA_SUCCESS,
  payload,
});

/**
 * Handles CLEAR_NOTIFICATION_LOADING Action
 * @return {Object} Object
 */
export const clearLoading = () => ({
  type: CLEAR_NOTIFICATION_LOADING,
});

/**
 * Action Creator for Notifications
 * @return {Object} Object
 */
export const getNotifactions = () => ({
  type: NOTIFICATIONS_REQUEST,
});

/**
 * Action Creator for Notifications on Success
 * @param {*} payload payload
 * @return {Object} Object
 */
export const getNotifactionsSuccess = (payload) => ({
  type: NOTIFICATIONS_REQUEST_SUCCESS,
  payload,
});

/**
 * Action Creator for Global Notifications
 * @return {Object} Object
 */
export const getGlobalNotifications = () => ({
  type: GLOBAL_NOTIFICATIONS_REQUEST,
});

/**
 * Action Creator for Global Notifications on Success
 * @param {*} payload payload
 * @return {Object} Object
 */
export const getGlobalNotificationsSuccess = (payload) => ({
  type: GLOBAL_NOTIFICATIONS_REQUEST_SUCCESS,
  payload,
});

/**
 * Action Creator for Global Notifications Update
 * @param {Oject} payload payload
 * @return {Object} Object
 */
export const updateGlobalNotifications = (payload) => ({
  type: UPDATE_GLOBAL_NOTIFICATIONS_REQUEST,
  payload,
});

/**
 * Action Creator for Global Notifications Update on Success
 * @param {Oject} payload payload
 * @returns {Object} Object
 */
export const updateGlobalNotificationsSuccess = (payload) => ({
  type: UPDATE_GLOBAL_NOTIFICATIONS_SUCCESS,
  payload,
});

/**
 * Action Creator for Specific Customer Notifications
 * @param {number} id id
 * @return {Object} Object
 */
export const getCustomerNotifications = (id) => ({
  type: CUSTOMER_NOTIFICATIONS_REQUEST,
  payload: id,
});

/**
 * Action Creator for Specific Customer Notifications on Success
 * @param {Object} payload payload
 * @return {Object} Object
 */
export const getCustomerNotificationsSuccess = (payload) => ({
  type: CUSTOMER_NOTIFICATIONS_SUCCESS,
  payload: { ...payload },
});

/**
 * Action Creator for Updating Specific Customer Notifications
 * @param {Object} payload payload
 * @returns {Object} Object
 */
export const updateCustomerNotifications = (payload) => ({
  type: UPDATE_CUSTOMER_NOTIFICATIONS_REQUEST,
  payload,
});

/**
 * Action Creator for Updating Specific Customer Notifications on Success
 * @param {Object} payload payload
 * @returns {Object} Object
 */
export const updateCustomerNotificationsSuccess = (payload) => ({
  type: UPDATE_CUSTOMER_NOTIFICATIONS_SUCCESS,
  payload: { ...payload },
});
